import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC33BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    actualizarFC_33Estatus, actualizarFileFC_33,
    agregarFileFC_33, resetDataFC_33,
    actualizarFC_33Fecha
} from '../../../redux/DucksBeneficiario/FC_33Ducks';
import moment from 'moment'


const DocumentacionFC_33Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_33Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_33Solicitud.dataDocumentacion)
    const  fechaHoy = moment().format('YYYY-MM-DD');
    const filesFC_33 = useSelector(store => store.FC_33Solicitud.files)
    const filesProductosFC_33 = useSelector(store => store.FC_33Solicitud.filesProductos)
    let filesMap = useSelector(store => store.FC_33Solicitud.filesMap)
    let filesProductosMap = useSelector(store => store.FC_33Solicitud.filesProductosMap)
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {
        const countArchivos = await countFiles()
        const totalFilesGenerales = (files.filter(file => file.estatus === true)).length
        const totalFilesProductos = (filesProductos.filter(file => file.estatus === true)).length
        const contadorArchivo = totalFilesGenerales + totalFilesProductos

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = {fechasolicitud:fecha,idfc33_solicitudenvasadonaciona:data.idfc33_solicitudenvasadonaciona}
            await dispatch(actualizarFC_33Fecha(solicitud))
            setFolio(data.folio)
            const idSolicitud = data.idfc33_solicitudenvasadonaciona
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_33 = 7
            const tabla = tablaFC_33
            await dispatch(actualizarFC_33Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_33())
            setEnvioCorrecto(true)
        }
    }

    const countFiles = async () => {
        let count = 2
        for (const i in data.fc_33_anexoproducto) {
            const filesAnalisis = data.fc_33_anexoproducto[i].numeroanalisis.split(',')
            //const filesCertificado = data.fc_33_anexoproducto[i].numerocertificado.split(',')
            count += filesAnalisis.length //+ filesCertificado.length +1
        }
        return count
    }

    React.useEffect(() => {
        if (filesFC_33?.data) {
            let newFiles = []
            for (const file of filesFC_33.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }

        if (filesProductosFC_33?.data) {
            let newFiles = []
            for (const file of filesProductosFC_33.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilesProductos(newFiles)
        }

    }, [data])


    /*React.useEffect(() => {
        return () => {
            dispatch(resetDataFC_33())
        }
    }, [])*/


    //FILES GENERALES
    const [files, setFile] = React.useState([])
    const handdleFile = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_33/agregarNuevoFC_33AnexosArchivos'
        }
        const result = await dispatch(agregarFileFC_33(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_33archivos
            objectFile.estatus = true
            setFile(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }


    }

    const handdleRemovePrev = async (objectFile) => {

        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_33/actualizarFormatoFC33_AnexosArchivos'
                }
                const result = await dispatch(actualizarFileFC_33(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_33/agregarNuevoFC_33AnexosArchivos'
                    }
                    result = await dispatch(agregarFileFC_33(data))
                }
                if (result.payload.data?.data) {
                    setFile(newFiles)
                    return true
                } else {
                    const newFiles = files.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFile(newFiles)
                    return false
                }
            }
        }
    }

    // //FILES PRODUCTOS
    //handdleFile: , handdleRemovePrev: , files:  }}
    const [filesProductos, setFilesProductos] = React.useState([])
    const handdleFileProducto = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_33/agregarNuevoFC_33AnexosArchivosProducto'
        }
        const result = await dispatch(agregarFileFC_33(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_33archivoproducto
            objectFile.estatus = true
            setFilesProductos(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }

    }

    const handdleRemoveProductoPrev = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesProductos.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_33/actualizarFormatoFC33_AnexosArchivosProducto'
                }
                const result = await dispatch(actualizarFileFC_33(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_33/agregarNuevoFC_33AnexosArchivosProducto'
                    }
                    result = await dispatch(agregarFileFC_33(data))
                }
                if (result.payload.data?.data) {
                    setFilesProductos(newFiles)
                    return true
                } else {
                    const newFiles = filesProductos.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesProductos(newFiles)
                    return false
                }
            }
        }
    }


    const FilesGenerales = () => {
        return (
            <div>
                <Collapsible trigger="Documentación general" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGJE'} tabla={"FC_33_anexos"}
                            filesMap={filesMap}
                            textLabel={`Juego de cada etiqueta: `} textoTooltip='que ostente el producto por cada presentación y marca (cuando las etiquetas no cuenten con aprobación del Organismo de Certificación para su uso).'
                            idAnexoFK={data.idfc33_solicitudenvasadonaciona} />

                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGME'} tabla={"FC_33_anexos"}
                            filesMap={filesMap}
                            textLabel={`Muestra del embalaje y Solicitud para la autorización de uso de marca e imagen corporativa COMERCAM (FC-05): `}
                            textoTooltip='cuando el embalaje cuente con el signo distintivo del COMERCAM y/o contraseña oficial NOM. La marca y signo distintivo COMERCAM y/o la contraseña oficial NOM solo pueden utilizarse en producto que cumpla con la NOM-070-SCFI-2016, previa autorización del Organismo de Certificación.'
                            idAnexoFK={data.idfc33_solicitudenvasadonaciona} />

                    </div>
                </Collapsible>
            </div>
        )
    }
    const FilesProductos = () => {
        let file = []
        let certificadoAnalisis = []
        return (
            <div>
                <Collapsible trigger="Documentación de productos" className='mb-3'>
                    {data.fc_33_anexoproducto?.map((anexo, index) => (

                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            <label className='text-center'>Producto:{Number(index) + Number(1)}</label>
                            {file = anexo.numeroanalisis.split(',')}
                            {certificadoAnalisis = anexo.numerocertificado.split(',')}
                            {file.map((analisis, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_33_anexos"}
                                    textLabel={`Análisis de laboratorio ${analisis} :`} idAnexoFK={anexo.idfc33_anexoproducto} id={`DPAL${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                            {certificadoAnalisis.map((certificado, i) => (
                                <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_33_anexos"}
                                    textLabel={`Certificado NOM de producto a granel ${certificado}: `} idAnexoFK={anexo.idfc33_anexoproducto} id={`DPCA${index}${i}`} textoTooltip=''
                                    filesMap={filesProductosMap}
                                />
                            ))}
                            <ArchivoComponent api={{ handdleFile: handdleFileProducto, handdleRemovePrev: handdleRemoveProductoPrev, files: filesProductos }} tabla={"FC_33_anexos"}
                                textLabel={`Etiqueta aprobada: `} idAnexoFK={anexo.idfc33_anexoproducto} id={`DPJE${index}`} textoTooltip=''
                                filesMap={filesProductosMap}
                            />
                        </div>
                    ))}

                </Collapsible>
            </div>
        )
    }

    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {/*FilesGenerales()*/}
                    {FilesProductos()}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envio</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_33Component)
